
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './lib/amplify';
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import PrivateRoute from './components/RBAC/PrivateRoute.js';
import { Auth } from 'aws-amplify';
import Loader from './components/Loader';
import { buyerRoles, sellerRoles, adminRoles, projectManagerRoles } from './config/ROLES.js';
import CommonDashboardLayout from './components/Dashboard/CommonDashboardLayout';
import { BUYER_MENU_ITEMS, SELLER_MENU_ITEMS, ADMIN_MENU_ITEMS, PROJECT_MANAGER_MENU_ITEMS } from './components/Dashboard/sidebarMenuConfig';

// Onboarding Imports
import OnboardingStart from './components/SignUp/OnboardingStart';
import SignUp from './components/SignUp/SignUp';
import LoginLayout from './Pages/LOGIN/LoginLayout';
import ForgetPasswordLayout from './Pages/LOGIN/ForgetPassword/ForgetPasswordLayout';
import { OnboardingProvider } from './context/OnboardingContext';
import IndustrySelection from './components/SignUp/IndustrySelection';
import TeamMembers from './components/SignUp/TeamMembers';
import EmailVerification from './components/SignUp/EmailVerification';
import OtpProcess from './components/SignUp/OtpProcess';
import VerificationSuccess from './components/SignUp/VerificationSuccess';
import NewPassword from './components/Login/NewPassword';
import AcceptInviteForm from './components/SignUp/AcceptInviteForm';
import InviteEmailVerification from './components/SignUp/inviteEmailVerification';
import InviteVerificationSuccess from './components/SignUp/InviteVerificationSuccess';

// Buyer Dashboard Imports
import AdditionalInfoForm from './Pages/BuyerDashboard/AdditionalInfoForm';
import Dashboard from './Pages/BuyerDashboard/Dashboard';
import Setting from './Pages/BuyerDashboard/Setting';
import User from './Pages/BuyerDashboard/User';
import Projects from './Pages/BuyerDashboard/Projects';
import Requirements from './Pages/BuyerDashboard/Requirements';
import ReviewSellers from './Pages/BuyerDashboard/ReviewSellers';
import Communications from './Pages/BuyerDashboard/Communications';
// import MultiStepRequirementForm from './Pages/BuyerDashboard/CreateRequirements';

// Seller Dashboard Imports
import SellerSetting from './Pages/SellerDashboard/Setting';
import Sellerdashboard from './Pages/SellerDashboard/Dashboard.js';
import SellerRequirement from './Pages/SellerDashboard/Requirement.js';
import SellerProject from './Pages/SellerDashboard/Projects.js';
import SellerCommunications from './Pages/SellerDashboard/Communications.js';
import SellerAdditionalInfoForm from './Pages/SellerDashboard/AdditionalInfoForm.js';
import SellerDetailedRFQs from "./Pages/SellerDashboard/DetailedRFQs";
import SellerUser from './Pages/SellerDashboard/User';

// Admin Dashboard Imports
import AdminDashboard from "./Pages/AdminDashboard/Dashboard";
import AdminContracts from "./Pages/AdminDashboard/Contracts";
import AdminRFQs from "./Pages/AdminDashboard/RFQs";
import AdminProjects from "./Pages/AdminDashboard/Projects";
import AdminBuyer from "./Pages/AdminDashboard/Buyer";
import AdminSeller from "./Pages/AdminDashboard/Seller";
import AdminProjectManager from "./Pages/AdminDashboard/ProjectManager";
import AdminDetailedRFQs from "./Pages/AdminDashboard/DetailedRFQs";
import AdminCommunications from "./Pages/AdminDashboard/Communications";
import AdminSendNotifications from "./Pages/AdminDashboard/SendNotifications";
import AdminBuyerForm from "./components/AdminDashboard/RegistrationForms/Form.js";
// import AdminSellerForm from "./components/AdminDashboard/RegistrationForms/SellerForm.js";
import AdminCompanyInfo from "./Pages/AdminDashboard/BuyerTabs/CompanyInfo.js";
import AdminSellerCompanyInfo from "./Pages/AdminDashboard/SellerTabs/CompanyInfo.js";
import AdminProjectManagerCompanyInfo from "./Pages/AdminDashboard/ProjectManagerTabs/CompanyInfo.js";
import AdminLegalInfo from "./Pages/AdminDashboard/BuyerTabs/LegalInfo.js";
import AdminFinancialDetails from "./Pages/AdminDashboard/BuyerTabs/FinancialDetails.js";
import AdminTechnicalCapabilities from "./Pages/AdminDashboard/BuyerTabs/TechnicalCapabilities.js";
import AdminCertCompliance from "./Pages/AdminDashboard/BuyerTabs/CertCompliance.js";
import AdminSupplierProgram from "./Pages/AdminDashboard/BuyerTabs/SupplierProgram.js";
import AdminReferences from "./Pages/AdminDashboard/BuyerTabs/References.js";

//Project Manager Dashboard Imports
import ProjectManagerSetting from './Pages/ProjectManagerDashboard/Setting';
import ProjectManagerDashboard from './Pages/ProjectManagerDashboard/Dashboard.js';
import ProjectManagerProjects from "./Pages/ProjectManagerDashboard/Projects.js";
import ProjectManagerCommunications from "./Pages/ProjectManagerDashboard/Communications";

import UpdateProjectManagerForm from './Pages/ProjectManagerDashboard/UpdateProjectManagerForm';
import UnauthorizedPage from './Pages/UnauthorizedPage';

function App() {
  window.AmplifyAuth = Auth;

  return (
    <OnboardingProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/buyer-dashboard" replace />} />
          <Route path="/login" element={<LoginLayout />} />
          <Route path="/forget-password" element={<ForgetPasswordLayout />} />
          <Route path="/onboarding" element={<OnboardingStart />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/industry-selection" element={<IndustrySelection />} />
          <Route path="/team-members" element={<TeamMembers />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/otp-process" element={<OtpProcess />} />
          <Route path="/verification-success" element={<VerificationSuccess />} />
          <Route path="/preloader" element={<Loader />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/accept-invite/:id" element={<AcceptInviteForm />} />
          <Route path="/invite-email-verification" element={<InviteEmailVerification />} />
          <Route path="/invite-verification-success" element={<InviteVerificationSuccess />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />

          {/* Buyer Dashboard Routes */}
          <Route
            path="/buyer-dashboard" element={<PrivateRoute allowedRoles={buyerRoles} requiredPermission="viewBuyerDashboard"><CommonDashboardLayout menuItems={BUYER_MENU_ITEMS} roleType="buyer" /> </PrivateRoute>}
          >
            <Route index element={<Dashboard />} />
            <Route path="users" element={<User />} />
            <Route path="settings" element={<Setting />} />
            <Route path="requirements" element={<Requirements />} />
            <Route path="projects" element={<Projects />} />
            <Route path="additional-info" element={<AdditionalInfoForm />} />
            <Route path="review-sellers/:id" element={<ReviewSellers />} />
            <Route path="communication/:id" element={<Communications />} />
            {/* <Route path="create-Requirements" element={<MultiStepRequirementForm/>} /> */}
          </Route>

          {/* Seller Dashboard Routes */}
          <Route path="/seller-dashboard" element={<PrivateRoute allowedRoles={sellerRoles} requiredPermission="viewSellerDashboard"> <CommonDashboardLayout menuItems={SELLER_MENU_ITEMS} roleType="seller" /> </PrivateRoute>}
          >
            <Route index element={<Sellerdashboard />} />
            <Route path="requirements" element={<SellerRequirement />} />
            <Route path="users" element={<SellerUser />} />
            <Route path="settings" element={<SellerSetting />} />
            <Route path="projects" element={<SellerProject />} />
            <Route path='communication/:id' element={<SellerCommunications />} />
            <Route path="additional-info" element={<SellerAdditionalInfoForm />} />
            <Route path="detailed-rfq/:id" element={<SellerDetailedRFQs />} />
          </Route>

          {/* Admin Dashboard Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute allowedRoles={adminRoles} requiredPermission="viewAdminDashboard">
                <CommonDashboardLayout menuItems={ADMIN_MENU_ITEMS} roleType="admin" />
              </PrivateRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="buyers" element={<AdminBuyer />} />
            <Route path="buyers/:id" element={<AdminBuyerForm role='Buyer' />}>
              <Route index element={<Navigate to="company-info" replace />} />
              <Route path="company-info" element={<AdminCompanyInfo />} />
              <Route path="legal-info" element={<AdminLegalInfo />} />
              <Route path="financial-details" element={<AdminFinancialDetails />} />
              <Route path="tech-capabilities" element={<AdminTechnicalCapabilities />} />
              <Route path="cert-compliance" element={<AdminCertCompliance />} />
              <Route path="references" element={<AdminReferences />} />
              <Route path="supplier-program" element={<AdminSupplierProgram />} />
            </Route>
            <Route path="sellers" element={<AdminSeller />} />
            <Route path="sellers/:id" element={<AdminBuyerForm role='Seller' />}>
              <Route index element={<Navigate to="company-info" replace />} />
              <Route path="company-info" element={<AdminSellerCompanyInfo />} />
              <Route path="legal-info" element={<AdminLegalInfo />} />
              <Route path="financial-details" element={<AdminFinancialDetails />} />
              <Route path="tech-capabilities" element={<AdminTechnicalCapabilities />} />
              <Route path="cert-compliance" element={<AdminCertCompliance />} />
              <Route path="references" element={<AdminReferences />} />
              <Route path="supplier-program" element={<AdminSupplierProgram />} />
            </Route>

            <Route path="project-managers" element={<AdminProjectManager />} />
            <Route path="project-managers/:id" element={<AdminBuyerForm role='Project Manager' />}>
              <Route index element={<Navigate to="company-info" replace />} />
              <Route path="company-info" element={<AdminProjectManagerCompanyInfo />} />
            </Route>
            <Route path="contracts" element={<AdminContracts />} />
            <Route path="rfqs" element={<AdminRFQs />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="detailed-rfq/:id" element={<AdminDetailedRFQs />} />
            <Route path="communication/:id" element={<AdminCommunications />} />
            <Route path="send-notifications" element={<AdminSendNotifications />} />
          </Route>

          {/* Project Manager Dashboard Routes */}
          <Route
            path="/manager-dashboard"
            element={
              <PrivateRoute allowedRoles={projectManagerRoles} requiredPermission="viewManagerDashboard">
                <CommonDashboardLayout menuItems={PROJECT_MANAGER_MENU_ITEMS} roleType="projectManager" />
              </PrivateRoute>
            }
          >
            <Route index element={<ProjectManagerDashboard />} />
            <Route path="projects" element={<ProjectManagerProjects />} />
            <Route path="communication/:id" element={<ProjectManagerCommunications />} />
            <Route path="additional-info" element={<UpdateProjectManagerForm />} />
            <Route path="settings" element={<ProjectManagerSetting />} />
          </Route>

        </Routes>
      </Router>
    </OnboardingProvider>
  );
}

export default App;
